import React, { useState } from "react";
import { useListenToPaymentIframe } from "../../hooks";
import PaymentIframeLoadingAnimation from "./PaymentIframeLoadingAnimation";

import "./PaymentIframe.scss";

/**
 *
 * @description Should only use Qgiv specific domains, even when the form is
 * deployed on a custom domain.
 * @param {object} props
 * @param {string} props.defaultHeightOfPaymentIframe
 * @param {string} props.idOfPaymentIframe
 * @param {string} props.idOfPaymentIframeContainer
 * @param {string} props.originOfPaymentIframe
 * @param {string} props.urlOfPaymentIframe
 * @returns {React.ReactElement}
 */
const PaymentIframe = ({
    defaultHeightOfPaymentIframe,
    idOfPaymentIframe,
    idOfPaymentIframeContainer,
    originOfPaymentIframe,
    urlOfPaymentIframe,
}) => {
    const [hasLoadedPaymentIframe, setHasLoadedPaymentIframe] = useState(false);

    // Listen to post messages from the payment iframe
    useListenToPaymentIframe({
        hasLoadedPaymentIframe,
        originOfPaymentIframe,
        setHasLoadedPaymentIframe,
    });

    // Sets the height of the iframe prior to the initial resize message so
    // that we do not experience a big jump in the UI when this happens
    const style = {
        height: defaultHeightOfPaymentIframe,
    };

    // The id of the the containing div is used by the resize logic as any
    // attempts to target the iframe directly result in 3px of additional white
    // space being added in between these two elements.
    return (
        <div
            id={idOfPaymentIframeContainer}
            className="-callout -padding--0"
            style={style}
        >
            {!hasLoadedPaymentIframe && <PaymentIframeLoadingAnimation />}
            {/* The id of the payment iframe needs to match the element we use to create the post message */}
            <iframe
                id={idOfPaymentIframe}
                src={urlOfPaymentIframe}
                title="qgiv-payment-iframe"
            />
        </div>
    );
};

export default PaymentIframe;
